import React, { useState, useEffect } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

import VariationsTable from "./components/tyre-alarm";
import { TyreAlarms } from "./data/data";
import { Navigation } from "../../../components/app/Navigation";
import { AppLayout, Box, BreadcrumbGroup, ContentLayout, Header, Icon, Link, Spinner, SplitPanel } from "@cloudscape-design/components";

import { listTyreAlarms } from "../../../graphql/queries";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import { ListTyreAlarmsQueryVariables } from "../../../API";

const client = generateClient()



// import '@cloudscape-design/global-styles/index.css'

export default function WAlarmTyre() {
  const [activeHref, setActiveHref] = React.useState("/vehicles/tyres/alarms");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [list_TyreAlarms, setListTyre] = useState<TyreAlarms[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  //graphql apis
  useEffect(() => {
    fetchTyreAlarms();
  }, []);

  async function fetchTyreAlarms(limit= 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allAlarms: TyreAlarms[] = [];
      do {
        const variables: ListTyreAlarmsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listTyreAlarms,
          authMode : 'userPool',
          variables,
        });

        const tyrealarms = response.data.listTyreAlarms.items;
        nextToken = response.data.listTyreAlarms.nextToken ?? null;  // Ensure nextToken is either string or null
      
      const newAlarms: TyreAlarms[] = tyrealarms.map(tyrealarm => ({
          id: tyrealarm["id"],
          tyreId: tyrealarm["position"] ?? 0,
          sn: tyrealarm["serialnumber"] ?? "",
          sensorId: tyrealarm["sensorid"]  ?? 0,
          brand: tyrealarm["brand"] ?? "",
          typetyre: tyrealarm["typetyre"] ?? "",
          VehicleCode: tyrealarm["vehiclecode"] ?? "",
          Alarm: tyrealarm["alarms"] ?? "",      
          Timestamps: tyrealarm["timestamps"] ? [tyrealarm["timestamps"]] : [],
        })
      );

      allAlarms = [...allAlarms, ...newAlarms];
      } while (nextToken);


      setListTyre(allAlarms);
      setIsLoading(false);

    } catch (err) {
      console.log("error fetching todos : ", err);
    }
  }


  return ( <>
    <AppLayout
      breadcrumbs={
        <BreadcrumbGroup
        items={[
          {
            text: "Vehicles",
            href: "/vehicles",
          },
          {
            text: "Tyres ",
            href: "/vehicles/tyres",
          },         
          {
            text: "Alarms",
            href: "/vehicles/tyres/alarm",
          },         
          
         
        ]}
        />
      }
      navigation={
        <Navigation
          activeHref={activeHref}
          setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
            throw new Error('Function not implemented.');
          } }              // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
        />
      }
      //navigationOpen={true}
    //   navigation={
    //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
    //   }
      //notifications={
      //  <Flashbar
      //    items={[
      //      {
      //        type: "info",
      //        dismissible: true,
      //        content: "This is an info flash message.",
      //        id: "message_1",
      //      },
      //    ]}
      //  />
      //}
      toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
      onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
      tools={
        <HelpPanel
          footer={
            <div>
              <h3>
                Learn more <Icon name="external" />
              </h3>
              <ul>
                <li>
                  <a href="">Link to documentation</a>
                </li>
                <li>
                  <a href="">Link to documentation</a>
                </li>
              </ul>
            </div>
          }
          header={<h2>Help panel title (h2)</h2>}
        >
          <div>
            <p>
              This is a paragraph with some <b>bold text</b> and also some{" "}
              <i>italic text</i>.
            </p>
  
            <h3>h3 section header</h3>
            <ul>
              <li>Unordered list item.</li>
              <li>Unordered list item.</li>
            </ul>
  
            <h4>h4 section header</h4>
            <p>
              Code can be formatted as lines of code or blocks of code. Add
              inline code <code>like this</code> using a{" "}
              <code>{"<code>"}</code> tag.
              <pre>
                Or format blocks of code (like this) using a{" "}
                <code>{"<pre>"}</code> tag.
              </pre>
            </p>
  
            <h5>h5 section header</h5>
            <dl>
              <dt>This is a term</dt>
              <dd>This is its description.</dd>
              <dt>This is a term</dt>
              <dd>This is its description</dd>
            </dl>
          </div>
        </HelpPanel>
      }
      content={
        <ContentLayout
          header={
            <Header
              variant="h1"
              info={
                <Link
                  variant="info"
                  onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                >
                  Info
                </Link>
              }
              
            >
              {activeHref === "/vehicles/tyres/alarms"
                ? `Tyres Alarms`
                : ""}
            </Header>
          }
        >
          
            <div className="contentPlaceholder" style={{marginTop: isLoading ? "160px" : '0px'}}>
            {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading tyre data...</Box>
                </Box>
              ) : (
                <VariationsTable TyreMaster={list_TyreAlarms} />
              )}
            
            </div>
         
        </ContentLayout>
      }
      splitPanel={
        <SplitPanel header="Split panel header">
          Split panel content
        </SplitPanel>
      }
    />
  </>
  );
}
